import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

//<input type="checkbox" trueFalseValue trueValue="Y" falseValue="N" [(ngModel)]="property_Name">

@Directive({
  selector: 'input[type=checkbox][trueFalseValue]',
  host: {
    '(change)': 'onChange($event.target.checked)'
  },
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CheckBoxYNDirective,
      multi: true
    }
  ]
})

export class CheckBoxYNDirective implements ControlValueAccessor {

  private propagateChange = (_: any) => { };
  @Input() trueValue:string;
  @Input() falseValue:string;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) { }

  onChange(isChecked: any) {
    this.propagateChange(isChecked ? this.trueValue : this.falseValue);
  }

  //Model value to View
  writeValue(obj: any): void {
    if (obj === this.trueValue) {
      this.renderer.setProperty(this.elementRef.nativeElement, 'checked', true);
    } else {
      this.renderer.setProperty(this.elementRef.nativeElement, 'checked', false);
    }
  }

  //Update model value
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void { }

  setDisabledState?(isDisabled: boolean): void { }

}
